module.exports = __webpack_public_path__ + "media/images/experiences/mat-fc2b769f5b31c63cb4a37a213aa11750.jpg";